import { createApi } from '@reduxjs/toolkit/query/react';

import type { LogsListRequest, LogsListResponse } from './model';
import { baseQueryWithReauth } from '../../apis/baseQuery';
import { ApiResponse } from '../../model';

export const logsApi = createApi({
  reducerPath: 'logsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getLogs: builder.query<ApiResponse<LogsListResponse>, LogsListRequest>({
      query: (body) => ({
        url: 'list',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetLogsQuery } = logsApi;
